const axios = require('axios');
const FormData = require('form-data');
const errors = require('./errors');

const errHandler = err => {
  let options = err.config;

  if (err.response) {
    let response = err.response;

    // statusCode is checked in a lot of places, so clone the prop there.
    response.statusCode = response.status;

    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    if (options.resolveWithFullResponse) {
      // don't fail, just return the response
      return response;
    }

    // rethrow as a standard StatusCodeError
    throw new errors.StatusCodeError(response.status, response.data, options, response);
  } else if (err.request) {
    // The request was made but no response was received
    // `error.request` is an instance of http.ClientRequest
    throw new errors.RequestError(err, options, null);
  } else {
    // Something happened in setting up the request that triggered an Error
    throw new errors.SetupError(err, options);
  }
};

const requestInterceptor = r => {
  // modify request before sent
  r.use(function(options) {
    // if encoding is set and === null, we translate that to responseType = 'arraybuffer
    // don't override whatever the user may have set though.
    options.maxBodyLength = Infinity;
    options.maxContentLength = Infinity;
    if (options.encoding === null && !options.responseType) {
      options.responseType = 'arraybuffer';
    }

    // convert body => data
    options.data = options.data || options.body;

    // convert uri => url
    options.url = options.url || options.uri;

    // convert baseUrl => baseURL
    options.baseURL = options.baseURL || options.baseUrl;

    // convert qs => params
    options.params = options.params || options.qs;

    // convert formData -> data (overrides body and data)
    // code borrowed from request lib (https://github.com/request/request/blob/master/request.js#L319)
    if (options.formData) {
      const formData = options.formData;
      const form = new FormData();
      // add error handler?
      const appendFormValue = (key, value) => {
        if (value && value.hasOwnProperty('value') && value.hasOwnProperty('options')) {
          form.append(key, value.value, value.options);
        } else {
          form.append(key, value);
        }
      };
      for (let formKey in formData) {
        if (formData.hasOwnProperty(formKey)) {
          var formValue = formData[formKey];
          if (formValue instanceof Array) {
            for (var j = 0; j < formValue.length; j++) {
              appendFormValue(formKey, formValue[j]);
            }
          } else {
            appendFormValue(formKey, formValue);
          }
        }
      }

      // get generated headers, append those to the ones we have
      Object.assign(options.headers, form.getHeaders());

      // finally assign the form to axios
      options.data = form;
    }

    if (!options.headers) {
      options.headers = {};
    }

    if (!options.headers['User-Agent'] && !options.headers['user-agent']) {
      options.headers['User-Agent'] = 'concora/request-bot';
    }

    // delete the others
    delete options.body;
    delete options.uri;
    delete options.baseUrl;
    delete options.qs;
    delete options.formData;

    return options;
  }, errHandler);
};

const responseInterceptor = r => {
  // modify response before sent
  r.use(response => {
    let options = response.config;
    if (options.resolveWithFullResponse) {
      // statusCode is checked in a lot of places, so clone the prop there.
      response.statusCode = response.status;
      return response;
    }

    // otherwise, just return the raw data.
    return response.data;
  }, errHandler);
};

axios._create = axios.create;
axios.create = config => {
  let instance = axios._create(config);

  // wrap custom instance with our global interceptors
  requestInterceptor(instance.interceptors.request);
  responseInterceptor(instance.interceptors.response);
  return instance;
};

// wrap main axios instance with our global interceptors
requestInterceptor(axios.interceptors.request);
responseInterceptor(axios.interceptors.response);

module.exports = axios;
